import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import Home from "@/pages/Home";
import Disciplines from "@/pages/Disciplines";
import DisciplineDetail from "@/pages/DisciplineDetail";
import EventPage from "@/pages/Event";
import Schedule from "@/pages/Schedule";
import Federations from "@/pages/Federations";
import Athletes from "@/pages/Athletes";
import Results from "@/pages/Results";
import News from "@/pages/News";
import Partners from "@/pages/Partners";
import Contact from "@/pages/Contact";
import Register from "@/pages/Register";
import Legal from "@/pages/Legal";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-ink font-sans text-bone">
        <div className="grain-overlay" aria-hidden="true" />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/disciplines" element={<Disciplines />} />
            <Route path="/disciplines/:slug" element={<DisciplineDetail />} />
            <Route path="/event" element={<EventPage />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/federations" element={<Federations />} />
            <Route path="/athletes" element={<Athletes />} />
            <Route path="/results" element={<Results />} />
            <Route path="/news" element={<News />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/register" element={<Register />} />
            <Route path="/privacy" element={<Legal type="privacy" />} />
            <Route path="/terms" element={<Legal type="terms" />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
